<template>
    <div class="modal modal-open" id="modal-contacts-edit">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="firstname"
                                    >First name
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="new_data.firstname"
                                    id="firstname"
                                />
                                <span class="error" v-if="errors.firstname">{{
                                    errors.firstname
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="lastname"
                                    >Last name
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="new_data.lastname"
                                    id="lastname"
                                />
                                <span class="error" v-if="errors.lastname">{{
                                    errors.lastname
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="email"
                                    >E-mail
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="new_data.email"
                                    id="email"
                                />

                                <span class="error"></span>
                                <span class="error" v-if="errors.email">{{
                                    errors.email
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="title">Title</label>
                                <input
                                    type="text"
                                    v-model="new_data.title"
                                    id="title"
                                />
                            </div>
                        </div>
                        <div v-if="!isEdit" class="col-xl-6 col-lg-6">
                            <div class="form-field form-field--tree">
                                <label for="firstname"
                                    >System role
                                    <span style="color: red">*</span></label
                                >
                                <treeselect
                                    v-model="selectedRole"
                                    id="system_role"
                                    name="system_role"
                                    :multiple="false"
                                    :options="roles"
                                    :clearOnSelect="true"
                                />
                                <span class="error" v-if="errors.selectedRole"
                                    >Required</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 group-row">
                            <div class="group-row__label">Business role</div>
                            <div class="row">
                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--main-billing-contact"
                                        style="margin-bottom: 0"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="new_data.billingContact"
                                            id="billing-contact"
                                            class="billing-contact"
                                            name="billing_contact"
                                        />
                                        <label for="billing-contact">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        <span style="font-size: 12px"
                                            >Billing contact</span
                                        >
                                    </div>
                                </div>

                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--send-emails"
                                        style="margin-bottom: 0"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="new_data.salesPerson"
                                            id="sales-person"
                                            class="send-emails"
                                            name="sales-person"
                                        />
                                        <label for="sales-person">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        <span style="font-size: 12px"
                                            >Sales person</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-8">
                            <div class="row">
                                <div v-if="!isEdit" class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--main-billing-contact"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="new_data.createUser"
                                            id="form_data"
                                            class="form_data"
                                            name="form_data"
                                        />
                                        <label for="form_data">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        Create user
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--send-emails"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="new_data.sendEmails"
                                            id="send-emails"
                                            class="send-emails"
                                            name="send-emails"
                                        />
                                        <label for="send-emails">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        Send e-mails
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 group-row">
                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="address_line_1"
                                            >Address line 1</label
                                        >
                                        <input
                                            type="text"
                                            v-model="address_data.addressLine1"
                                            id="address_line_1"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="address_line_2"
                                            >Address line 2</label
                                        >
                                        <input
                                            type="text"
                                            v-model="address_data.addressLine2"
                                            id="address_line_2"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="town">Town</label>
                                        <input
                                            type="text"
                                            v-model="address_data.town"
                                            id="town"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        v-if="states.length"
                                        class="form-field form-field--tree"
                                        style="padding-right: 24px"
                                    >
                                        <label for="state">State</label>
                                        <treeselect
                                            v-model="address_data.state"
                                            id="state"
                                            :multiple="false"
                                            :options="states"
                                            :clearOnSelect="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--tree"
                                        style="padding-right: 24px"
                                    >
                                        <label for="country">Country</label>
                                        <treeselect
                                            v-model="address_data.country"
                                            :id="`country`"
                                            @select="changeCountry"
                                            :multiple="false"
                                            :options="countries"
                                            :clearOnSelect="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="zip">Zip</label>
                                        <input
                                            type="text"
                                            v-model="address_data.zip"
                                            id="zip"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row btn-wrap btn-wrap--center">
                        <button
                            @click.prevent="handleAdd"
                            class="btn btn--gray"
                        >
                            {{ isEdit ? "Save" : "Add contact" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addContactModal",
    props: {
        closeModal: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },

        roles: {
            type: Array,
        },
        countries: {
            type: Array,
        },

        isEdit: {
            type: Number,
            required: false,
        },
        editData: {
            type: Object,
            required: false,
        },
        onEdit: {
            type: Function,
            required: false,
        },
    },
    components: {
        Treeselect,
    },
    data() {
        return {
            selectedRole: 2,
            states: [],

            new_data: {
                firstname: "",
                lastname: "",
                email: "",
                title: "",
                salesPerson: false,
                billingContact: false,
                sendEmails: false,
                createUser: false,
            },

            address_data: {
                addressLine1: "",
                addressLine2: "",
                town: "",
                state: null,
                country: null,
                zip: "",
            },

            roles: [],

            errors: {
                firstname: false,
                lastname: false,
                email: false,
                selectedRole: false,
            },
        };
    },

    computed: {
        isValidEmail() {
            if (this.new_data.email) {
                return !/^[^@]+@\w+(\.\w+)+\w$/.test(this.new_data.email);
            }
        },
    },

    mounted() {
        if (this.isEdit) {
            let arr = JSON.parse(JSON.stringify(this.editData));
            this.new_data = arr.contact;
            this.address_data = arr.address;
            this.changeCountry({ id: arr.address.country });
        }
    },

    methods: {
        changeCountry(node, id) {
            axios
                .post("/agencies/address/getStatesByCountry", {
                    countryId: node.id,
                })
                .then((r) => {
                    this.states = r.data;
                });
        },

        handleClose(e) {
            this.closeModal(e);
        },

        onValidate() {
            this.errors = {
                firstname: false,
                lastname: false,
                email: false,
                selectedRole: false,
            };
            if (this.selectedRole === null) {
                if (!this.isEdit) {
                    this.errors.selectedRole = "Required";
                }
            }
            if (!this.new_data.firstname) {
                this.errors.firstname = "Required";
            }
            if (!this.new_data.lastname) {
                this.errors.lastname = "Required";
            }
            if (!this.new_data.email) {
                this.errors.email = "Required";
            }
            // if (this.isValidEmail) {
            //     this.errors.email = "The Email must be a valid.";
            // }
        },

        handleAdd(e) {
            this.onValidate();

            if (
                this.errors.email ||
                this.errors.firstname ||
                this.errors.lastname ||
                this.errors.selectedRole
            ) {
                return;
            }

            if (this.isEdit) {
                this.onEdit(this.isEdit, this.new_data, this.address_data);
                return;
            }

            this.onAdd({
                contact: {
                    firstname: this.new_data.firstname,
                    lastname: this.new_data.lastname,
                    email: this.new_data.email,
                    title: this.new_data.title,
                    role_id: this.selectedRole,
                    main_contact: this.new_data.billingContact,
                    sales_person: this.new_data.salesPerson,
                    create_user: this.new_data.createUser,
                    send_emails: this.new_data.sendEmails,
                },
                address: {
                    address1: this.address_data.addressLine1,
                    address2: this.address_data.addressLine2,
                    town: this.address_data.town,
                    country: this.address_data.country,
                    state: this.address_data.state,
                    zip: this.address_data.zip,
                },
            });
        },
    },
};
</script>
